module.exports = __webpack_public_path__ + "img/tullochd.886fa73e.jpg";